import { DepositNotes } from "./deposit-notes";
import { CapitalizationPolicy, InterestCalculationOption, InterestCalculationType, InterestPaymentFrequency, RecalculationMode, RenewalType } from "./deposit-template";

export type WorkflowState = 'DRAFT' | 'READY_FOR_APPROVAL' | 'WAITING_FOR_APPROVAL' | 'REPAIR' | 'REJECTED' | 'APPROVED';
export type BusinessState = 'NEW' | 'FUNDED' | 'MATURED' | 'CLOSING' | 'CLOSED';
export type DepositAgreementAction = 'EDIT' | 'SUBMIT_FOR_APPROVAL' | 'APPROVE' | 'SEND_TO_REPAIR'
  | 'REJECT' | 'DELETE' | 'FUND' | 'TOP_UP' | 'INTEREST_ACCRUAL' | 'CAPITALIZE'
  | 'ADJUST_INTEREST' | 'TERMINATE' | 'REPAY' | 'CLOSE' | 'PRINT';

export interface DepositActionAuthorization {
  action: DepositAgreementAction;
  allowed: boolean;
  reason?: string;
}

export interface DepositAuthorizationDetails {
  agreementId: string;
  workflowState: WorkflowState;
  businessState: BusinessState;
  actions: DepositActionAuthorization[];
}

export class DepositAgreement {
  id: string;

  agreementNumber: string;
  agreementDate: string;
  productTemplateId: string;
  productTemplateCode?: string;
  productTemplateName?: string;
  productDescription?: string;

  customerNumber?: string;
  customerName?: string;
  customerMiddleName?: string;
  customerSurname?: string;
  customerId?: string;
  customerGroupId?: string;
  customerFullName?: string;

  amount?: number;
  currency?: string;
  periodDays?: number;
  interestRateResolved?: number;
  maturityDate?: string;

  correspondingAccountNumber?: string;
  correspondentAccountId?: string;
  correspondentAccountNumber?: string;
  correspondentAccountCurrency?: string;
  interestCorrespondentAccountId?: string;
  interestCorrespondentAccountNumber?: string;
  interestCorrespondentAccountCurrency?: string;
  interestCorrespondingAccountNumber?: string;

  branchId?: string;
  branchCode?: string;
  branchName?: string;
  earlyWithdrawalAllowed?: boolean;
  recalculationMode?: RecalculationMode;
  customRecalculationRate?: number;
  penaltyOnEarlyWithdrawal?: number;
  refillable?: boolean;
  capitalizationPolicy?: CapitalizationPolicy;
  autoRenewal?: boolean;
  renewalType?: RenewalType;
  interestPaymentFrequency?: InterestPaymentFrequency;
  interestCalculationOption?: InterestCalculationOption;
  interestCalculationType?: InterestCalculationType;
  averageBalanceDays?: number;
  taxRate?: number;
  description: string;
  closingDate: string;
  fundingDate: string;
  lastAccrualDate: string;
  workflowState?: WorkflowState;
  businessState?: BusinessState;

  depositAmount?: number;
  depositOutstandingAmount?: number;
  calculatedInterest?: number;
  calculatedServiceFee?: number;
  interestRate?: number;
  depositPeriodMonths?: number;
  depositCorrespondingAccountNumber?: string;

  createdBy: string;
  approvedBy: string;
  createdAt: string;

  groupDeposit?: boolean;
  notes?: DepositNotes[];
  noteIds?: string[];
  depositAgreementNotes?:any[];
  linkedAccounts?: any[];
}
